import api from './api';

export const quoteService = {
  async getQuoteEntries({ page = 1, limit = 10, search = '', channelId = null, convertedOnly = false, menuName = '', delivery = '', occasion = '', startDate = '', endDate = '', paymentStatus = '', checkoutMatch = '' } = {}) {
    const params = { page, limit };

    if (search) {
      params.search = search;
    }

    if (channelId !== null && channelId !== undefined && channelId !== '') {
      const parsedChannelId = Number(channelId);
      if (Number.isFinite(parsedChannelId)) {
        params.channelId = parsedChannelId;
      }
    }

    if (convertedOnly) {
      params.convertedOnly = true;
    }

    if (menuName) {
      params.menuName = menuName;
    }

    if (delivery) {
      params.delivery = delivery;
    }

    if (occasion) {
      params.occasion = occasion;
    }

    if (startDate) {
      params.startDate = startDate;
    }

    if (endDate) {
      params.endDate = endDate;
    }

    // paid | pending | refunded | voided | none
    if (paymentStatus) {
      params.paymentStatus = paymentStatus;
    }

    // changed | unchanged | unknown
    if (checkoutMatch) {
      params.checkoutMatch = checkoutMatch;
    }

    const response = await api.get('/quotes', { params });
    return response.data;
  },

  async getQuoteEntry(id) {
    const response = await api.get(`/quotes/${id}`);
    return response.data.data;
  },

  async updateQuoteEntry(id, data) {
    const response = await api.put(`/quotes/${id}`, data);
    return response.data.data;
  },

  async deleteQuoteEntry(id) {
    const response = await api.delete(`/quotes/${id}`);
    return response.data.data;
  },

  async exportQuoteEntriesCsv({ search = '', channelId = null, convertedOnly = false, menuName = '', delivery = '', occasion = '', startDate = '', endDate = '', paymentStatus = '', checkoutMatch = '' } = {}) {
    const params = {};

    if (search) {
      params.search = search;
    }

    if (channelId !== null && channelId !== undefined && channelId !== '') {
      const parsedChannelId = Number(channelId);
      if (Number.isFinite(parsedChannelId)) {
        params.channelId = parsedChannelId;
      }
    }

    if (convertedOnly) {
      params.convertedOnly = true;
    }

    if (menuName) {
      params.menuName = menuName;
    }

    if (delivery) {
      params.delivery = delivery;
    }

    if (occasion) {
      params.occasion = occasion;
    }

    if (startDate) {
      params.startDate = startDate;
    }

    if (endDate) {
      params.endDate = endDate;
    }

    // paid | pending | refunded | voided | none
    if (paymentStatus) {
      params.paymentStatus = paymentStatus;
    }

    // changed | unchanged | unknown
    if (checkoutMatch) {
      params.checkoutMatch = checkoutMatch;
    }

    const response = await api.get('/quotes/export/csv', { params, responseType: 'blob' });

    let filename = `quote-entries-${new Date().toISOString().slice(0, 10)}.csv`;
    const disposition = response.headers['content-disposition'] || response.headers['Content-Disposition'];
    if (disposition) {
      const match = /filename="?([^"]+)"?/i.exec(disposition);
      if (match) {
        filename = match[1];
      }
    }

    return { blob: response.data, filename };
  },
};